/**
 * 订单备注列表。接口缺字段 / 详情 403 回落空对象时避免 [...null] 整页崩溃。
 * @param {unknown} orderNotes
 * @returns {object[]}
 */
export function normalizeOrderNotesList(orderNotes) {
	return Array.isArray(orderNotes) ? orderNotes : [];
}
